export default {
      id: "info-usage",
      viewBox: "0 0 48 48",
      url: __webpack_public_path__ + "img/icons.50d286a4.svg#info",
      toString: function () {
        return this.url;
      }
    }